import { render, staticRenderFns } from "./InfoFileBox.vue?vue&type=template&id=c7b09128&scoped=true&"
import script from "./InfoFileBox.vue?vue&type=script&lang=ts&"
export * from "./InfoFileBox.vue?vue&type=script&lang=ts&"
import style0 from "./InfoFileBox.vue?vue&type=style&index=0&id=c7b09128&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7b09128",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VIcon,VListItem,VListItemAction,VListItemAvatar,VListItemTitle,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c7b09128')) {
      api.createRecord('c7b09128', component.options)
    } else {
      api.reload('c7b09128', component.options)
    }
    module.hot.accept("./InfoFileBox.vue?vue&type=template&id=c7b09128&scoped=true&", function () {
      api.rerender('c7b09128', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/infodayco/shared/components/InfoFileBox.vue"
export default component.exports